import Vue from 'vue'
import App from '@/App.vue'

import router from '@/router/index'
import store from '@/store/index'

import { http } from '@/utils/http'
import language from '@/utils/language'
import validator from '@/utils/validator'

import '@/plugins/vuetify'
import '@/plugins/nprogress'
import '@/assets/css/main.css'

Vue.component('app-alert', () => import('./components/Alert/Alert'))
Vue.component('export', () => import('vue-json-excel'))

Vue.prototype.$settings = { // setting up this.$settings
  country: process.env.NODE_ENV !== 'production' ? '5cf9144f363ab8d27a88d5b2' : '5d497c86363ab80c51536dd4'
}
Vue.prototype.$http = http // setting up this.$http
Vue.prototype.$lang = language // setting up this.$lang
Vue.prototype.$validator = validator // setting up this.$rules
Vue.prototype.$can = store.getters.userCan // setting up user permissions - this.$can
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
